<div class="baseLoader" *ngIf="loaderVal" >
    <div>
      <img src="assets/images/loader.svg" width="70"/>
    </div>
</div>
